import { Component } from '@angular/core';
import {ReponseFicheComponent} from "../reponse-fiche.component";

@Component({
  selector: 'app-simple-reponse-fiche',
  templateUrl: './simple-reponse-fiche.component.html',
  styleUrls: ['./simple-reponse-fiche.component.scss']
})
export class SimpleReponseFicheComponent extends ReponseFicheComponent {

}
